module.exports = __webpack_public_path__ + "static/media/Utrecht_University_logo.12d62f29.png";